import { Offer, OfferStatus } from './types';

export const getOfferStatus = (offer: Offer): OfferStatus => {
  if (offer.used) return 'used';
  const now = new Date();
  if (offer.endDate && new Date(offer.endDate) < now) return 'expired';
  if (offer.startDate && new Date(offer.startDate) > now) return 'expired';
  return 'available';
};

export const getOfferImage = (offerNum?: string): string => {
  const images = ['/produit.jpeg', '/lavage.jpg', '/pneu.jpeg'];
  const num = parseInt(String(offerNum || '0').replace(/\D/g, '') || '0', 10);
  return images[num % 3];
};

